export const showLoadingScreen = () => ({
    type: 'SHOW_LOADING_SCREEN'
});

export const hideLoadingScreen = () => ({
    type: 'HIDE_LOADING_SCREEN'
});